import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';
import '../.././Hero.css';
import githubIcon from '../../assets/github-icon.svg';
import linkedinIcon from '../../assets/linkedin-icon.svg';
import locationIcon from '../../assets/location-icon.svg';
import mailIcon from '../../assets/mail-icon.svg';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success', 'error', or null

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // You'll need to replace these with your actual EmailJS credentials
      const result = await emailjs.send(
        'service_r1nuqgd', // EmailJS service ID
        'template_gtovkzk', // EmailJS template ID
        {
          from_name: formData.name,
          from_email: formData.email,
          subject: formData.subject,
          message: formData.message,
          to_name: 'John Yao', // Your name
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY // EmailJS public key from environment
      );

      console.log('Email sent successfully:', result);
      setSubmitStatus('success');
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (error) {
      console.error('Email send failed:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <h1>
        Get In <span className="highlight">Touch</span>
      </h1>
      <p>I'm always interested in new opportunities and collaborations. Feel free to reach out!</p>

      <div className="contact-content">
        <div className="contact-info">
          <h2>Contact Information</h2>
          <div className="contact-item">
            <span className="contact-icon">
              <img src={githubIcon} alt="" />
            </span>
            <div>
              <h3>GitHub</h3>
              <a href="https://github.com/hui-peng-john-yao" target="_blank" rel="noopener noreferrer">
                github.com/hui-peng-john-yao
              </a>
            </div>
          </div>
          <div className="contact-item">
            <span className="contact-icon">
              <img src={linkedinIcon} alt="" />
            </span>
            <div>
              <h3>LinkedIn</h3>
              <a
                href="https://www.linkedin.com/in/hui-peng-john-yao-2298b2376/"
                target="_blank"
                rel="noopener noreferrer"
              >
                linkedin.com/in/hui-peng-john-yao
              </a>
            </div>
          </div>
          <div className="contact-item">
            <span className="contact-icon">
              <img src={locationIcon} alt="" />
            </span>
            <div>
              <h3>Location</h3>
              <p>Ladera Ranch, CA</p>
            </div>
          </div>
          <div className="contact-item">
            <span className="contact-icon">
              <img src={mailIcon} alt="" />
            </span>
            <div>
              <h3>Email</h3>
              <a href="mailto:huipengjohnyao@gmail.com">huipengjohnyao@gmail.com</a>
            </div>
          </div>
        </div>

          <div className="contact-form">
            <h2>Send Me a Message</h2>
            
            {submitStatus === 'success' && (
              <div className="success-message">
                Thank you for your message! I'll get back to you soon.
              </div>
            )}
            
            {submitStatus === 'error' && (
              <div className="error-message">
                Sorry, there was an error sending your message. Please try again.
              </div>
            )}
            
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  disabled={isSubmitting}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  disabled={isSubmitting}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  disabled={isSubmitting}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="5"
                  required
                  disabled={isSubmitting}
                ></textarea>
              </div>
              
              <button 
                type="submit" 
                className="submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </div>
  );
}

export default Contact;